import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet"; // ✅ הוספת Helmet
import TaxiImages from "../../components/TaxiForSaleForSinglePage/TaxiImages";
import TaxiMainDetails from "../../components/TaxiForSaleForSinglePage/TaxiMainDetails";
import TaxiForSalePriceandPhone from "../../components/TaxiForSaleForSinglePage/TaxiForSalePriceandPhone";
import TaxiForSaleMainPagedes from "../../components/TaxiForSaleForSinglePage/TaxiForSaleMainPagedes";
import TaxiForSaleMoreInfotable from "../../components/TaxiForSaleForSinglePage/TaxiForSaleMoreInfotable";
import ArticlesPreview from "../../components/ArticlesPreviewBlog/ArticlesPreviewBlog";
import InsuranceSummaryHomepage from "../../components/InsuranceSummaryHomepage/InsuranceSummaryHomepage";
import BuyNewTaxiSiderHomePage from "../../components/BuyNewTaxiSiderHomePage/BuyNewTaxiSiderHomePage";
import NewTaxisHomePageCards from "../../components/NewTaxisHomePageCards/NewTaxisHomePageCards";
import Yad2ContactForm from '../../components/Yad2ContactForm/Yad2ContactForm';
import AdsMoshezion from '../../components/Ads/AdsMoshezion/AdsMoshezion';
import MiniProductsCarouselHome from "../../components/MiniProductsCarouselHome/MiniProductsCarouselHome";
import "./TaxiSinglePage.css";

const TaxiSinglePage = () => {
    const { id } = useParams();
    const [taxi, setTaxi] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios.get(`/api/taxiforsale`)
            .then(res => {
                console.log("🔹 כל הנתונים מהשרת:", res.data);
                const foundTaxi = res.data.find(item => item.id === id); // חיפוש לפי ID
                if (foundTaxi) {
                    setTaxi(foundTaxi);
                } else {
                    setError("❌ המונית לא נמצאה");
                }
                setLoading(false);
            })
            .catch(err => {
                console.error("❌ שגיאה בשליפת הנתונים:", err);
                setError("❌ לא ניתן לטעון את הנתונים");
                setLoading(false);
            });
    }, [id]);

    if (loading) return <p>🔄 טוען נתונים...</p>;
    if (error) return <p>{error}</p>;

    return (
        <>
                    <Helmet>
                    <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "${taxi["דגם"] || "מונית"}",
  "description": "${taxi["תיאור"] || "מונית למכירה"}",
  "image": "${taxi["תמונות"]?.[0] || ""}",
  "offers": {
    "@type": "Offer",
    "price": "${taxi["מחיר"] || ""}",
    "priceCurrency": "ILS",
    "availability": "https://schema.org/InStock"
  }
}
`}
</script>

                <title>{`מונית למכירה - ${taxi["דגם"] || "לא נמצא"} | BuyTaxi`}</title>
                <meta name="description" content={`מונית ${taxi["דגם"] || "לא נמצא"} למכירה במחיר ${taxi["מחיר"] || "לא זמין"} - קנה את המונית שלך עכשיו דרך BuyTaxi!`} />

                {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
                <meta property="og:title" content={`מונית ${taxi["דגם"] || "לא נמצא"} למכירה | BuyTaxi`} />
                <meta property="og:description" content={`מחפש מונית למכירה? מצא את הדיל המשתלם ביותר ב-BuyTaxi!`} />
                <meta property="og:image" content={taxi["תמונות"]?.[0] || "%PUBLIC_URL%/og-image.jpg"} />
                <meta property="og:url" content={`https://buytaxi.co.il/taxi/${id}`} />
                <meta property="og:type" content="website" />
                <meta name="keywords" content="קניית מוניות, מוניות למכירה, רכישת מונית, מכירת מונית, זכויות ציבוריות, רכישת זכויות ציבוריות, ביטוח למונית, ביטוח מוניות, BuyTaxi, קנה טקסי, ליסינג למוניות, השכרת מוניות, מוניות יד שנייה, מוניות פיקס, מוניות פיקס למכירה, טרייד אין למוניות, מונית חדשה, מונית משומשת, שוק המוניות, מוניות לעסק, מסלולי מימון למוניות, מימון לרכישת מוניות, מימון מונית, מונית ספיישל, תחנות מוניות, לוח מוניות למכירה, הזדמנויות עסקיות במוניות, תיווך מוניות, מציאת נהג למונית, קנייה בטוחה של מוניות, השקעה במוניות, ביטוח חובה למונית, ביטוח מקיף למונית, ביטוח צד ג' למונית, נהגים למוניות, ליסינג מימוני למוניות, ליסינג תפעולי למוניות, מס ליסינג מוניות, מחירי מוניות, דגמי מוניות מומלצים, מוניות במימון מלא, הלוואות למוניות, מוניות חשמליות, מוניות היברידיות, מונית VIP, מונית יוקרה, מוניות נגישות, מונית נגישה לנכים, תחנות מוניות בישראל, נהגי מוניות, עבודה כנהג מונית, רישוי מוניות, חוקים למוניות, קניית זכות ציבורית, מכירת זכות ציבורית, שווי זכויות ציבוריות למונית, קנייה בטוחה של זכויות ציבוריות, איך לקנות מונית, איך למכור מונית, פורום נהגי מוניות, קבוצות פייסבוק למוניות" />
                {/* Twitter Meta Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`מונית ${taxi["דגם"] || "לא נמצא"} למכירה | BuyTaxi`} />
                <meta name="twitter:description" content={`מצא מונית למכירה במחיר הטוב ביותר עכשיו ב-BuyTaxi!`} />
                <meta name="twitter:image" content={taxi["תמונות"]?.[0] || "%PUBLIC_URL%/og-image.jpg"} />
                <meta name="twitter:site" content="@buytaxi" />

                {/* Keywords (SEO) */}
                <meta name="keywords" content={`מונית למכירה, קניית מונית, ${taxi["דגם"] || "לא נמצא"}, מונית יד שנייה, מונית חדשה, זכויות ציבוריות, טרייד אין למוניות, BuyTaxi`} />

                {/* Canonical URL (מניעת כפילות תוכן) */}
                <link rel="canonical" href={`https://buytaxi.co.il/taxi/${id}`} />
            </Helmet>
            <div className="taxi-single-container">
                <div className="TaxiSingaleImages">
                    {taxi["תמונות"] && <TaxiImages images={taxi["תמונות"]} />}
                </div>
                <div className="Taxiforsalemaindetailspage">
                <TaxiMainDetails taxi={taxi} />
<TaxiForSalePriceandPhone 
  price={taxi["מחיר"]}
  phoneNumber={taxi["טלפון"]?.trim()}
  whatsappLink={`https://wa.me/972${taxi["טלפון"]?.replace(/\D/g, '').slice(1)}?text=${encodeURIComponent(`היי, בקשר למונית שפירסמת בקנה טקסי:\nhttps://buytaxi.co.il/taxi/${taxi.id}`)}`}
  taxiId={taxi.id}
/>


                </div>
                <div className="Taxiforsalemaindescripage">
                    <div className="Taxiforsalemaindescripage50"></div>
                    <TaxiForSaleMainPagedes taxi={taxi} />
                </div>
                <div className="taxiforsalemoreinfotablecsscode">
                    <div className="TaxiForSaleMoreInfotablediv">
                    <TaxiForSaleMoreInfotable />
                    </div>
                    <div className="AdsMosheziondivsingalepagetaxi">
                    <AdsMoshezion />
                    </div>
                </div>
                <div className="ProductsTaxiSingalePage">
                  <h2 className="ProductsTaxiSingalePageH2">
                    רוכשים מונית חדשה? תפנקו את עצמכם במוצרים למונית!
                  </h2>
                  <p className="ProductsTaxiSingalePageP">
                    במחירים הכי משתלמים שיש!
                  </p>
                  <MiniProductsCarouselHome />
                </div>
<div className="NewTaxisHomePageCardsAtPageDiv">
  <NewTaxisHomePageCards />

  <div className="CenterButtonWrapper">
    <a href="/AllTaxiYad2ForSalepage" className="SeeAllYad2TaxisButton">
      כל המוניות יד 2
    </a>
  </div>
</div>

        {/* טופס פנייה */}
        <div className='AllTaxiYad2ForSalePage-form'>
          <Yad2ContactForm />
        </div>
                <div className="InsuranceSummaryHomepage">
  <InsuranceSummaryHomepage />
</div>
<div className="BuyNewTaxiSiderHomePageHomepage">
  <BuyNewTaxiSiderHomePage />
</div>
                <div className="ArticlesPreviewHomePage">
  <ArticlesPreview />
</div>
            </div>
        </>
    );
};

export default TaxiSinglePage;